import {Object3D, Vector3} from "three";
import DefaultSceneManager from '../classes/DefaultSceneManager';
import Scenario from "../classes/scenarioElements/Scenario";
import ProjectSaver from '../classes/ProjectSaver';
import Action from "../classes/Action";
import {CustomEventTypes, SaveModificationTypes} from "../globals";
import MathUtils from "../classes/utilities/MathUtils";
import {ActionDescription, ActionParameters} from "../classes/api/APIDecorators";
import {RegisterActionWithAPI} from "../classes/api/Decorators";

@ActionDescription("Sets the scale of the selected objects. ")
@ActionParameters({objects: "Object3D[]", newScales: "Vector3[]", oldScales: "Vector3[]", newPositions: "Vector3[]", oldPositions: "Vector3[]"})
@RegisterActionWithAPI("SetObjectScaleAction")
export default class SetObjectScaleAction extends Action
{
	constructor(objects: Object3D[], newScales: Vector3[], oldScales: Vector3[], newPositions: Vector3[]| null, oldPositions: Vector3[]| null)
	{
		const actionName = objects.length > 1 ? "Scaled objects" : "Scaled " + objects[0].name;
		const isDefaultState = Scenario.currentStep()?.isDefault();

		super([objects, newScales, newPositions, isDefaultState],
			[objects, oldScales, oldPositions, isDefaultState],
			actionName,
			[objects, newScales, oldScales]);
	}

	do(objects: Object3D[], scales: Vector3[], positions: Vector3[] | null, isDefaultState: boolean)
	{
		if (isDefaultState)
		{
			DefaultSceneManager.getInstance().syncNativeObjectVectorProperty(objects, 'scale', scales);
			if (positions)
			{
				DefaultSceneManager.getInstance().syncNativeObjectVectorProperty(objects, 'position', positions);
			}
		}

		for (let i = 0; i < objects.length; i++)
		{
			const object = objects[i];
			object.scale.copy(scales[i]);
			ProjectSaver.getInstance().markModifiedObject(object, SaveModificationTypes.Scale);
			if (positions)
			{
				object.position.copy(positions[i]);
				ProjectSaver.getInstance().markModifiedObject(object, SaveModificationTypes.Position);
			}
		}

		document.dispatchEvent(new CustomEvent(CustomEventTypes.selectedObjectScaleChanged));
		if (positions)
		{
			document.dispatchEvent(new CustomEvent(CustomEventTypes.selectedObjectPositionChanged));
		}
	}

	verify(objects: Object3D[], newScales: Vector3[], oldScales: Vector3[])
	{
		if (objects.length === 0 || objects.length !== newScales.length || objects.length !== oldScales.length || newScales.length !== oldScales.length)
		{return false;}

		for (let i = 0; i < objects.length; i++)
		{
			if (!MathUtils.areVectorsEqual(newScales[i], oldScales[i]))
			{
				return true;
			}
		}

		return false;
	}
}
